// Munich Voices user-base composition (demo data).
// Perspective colors mirror the cohort palette used across the theses charts.

const C = {
  green:  '#7ECBA5',
  blue:   '#86CBF1',
  amber:  '#D4A244',
  salmon: '#E88B7A',
};

// Total verified Munich Voices across the event series.
export const TOTAL_VOICES = 12480;

// ── By perspective (verification tier / role) - sums to 100 ──
// Ordered from the small verified core out to the broad public.
export const BY_PERSPECTIVE = [
  {
    id: 'participants', color: C.blue,
    label: 'In the Room',
    blurb: 'Accredited delegates attending the conference and townhalls.',
    pct: 8,
  },
  {
    id: 'experts', color: C.green,
    label: 'Experts',
    blurb: 'Security-policy researchers and practitioners invited by the MSC.',
    pct: 14,
  },
  {
    id: 'future_leaders', color: C.amber,
    label: 'Students',
    blurb: 'Students from universities across Europe.',
    pct: 33,
  },
  {
    id: 'public', color: C.salmon,
    label: 'Broad Public',
    blurb: 'A phone-verified representative sample of the wider public.',
    pct: 45,
  },
];

// ── By region - sums to 100 ──
export const BY_REGION = [
  { id: 'western_eu', label: 'Western Europe', detail: 'Germany · France · Italy · Iberia · Benelux', pct: 52 },
  { id: 'eastern_eu', label: 'Eastern Europe', detail: 'Poland · Baltics · Finland · Romania',         pct: 23 },
  { id: 'north_america', label: 'North America', detail: 'US · Canada',                                 pct: 11 },
  { id: 'asia', label: 'Asia',                   detail: 'incl. Japan · India · Singapore',             pct: 8  },
  { id: 'rest', label: 'Rest of world',          detail: 'S. America · Africa · Oceania',               pct: 6  },
];

// ── By age - sums to 100 ──
export const BY_AGE = [
  { id: '18_25', label: '18–25', pct: 26 },
  { id: '26_40', label: '26–40', pct: 38 },
  { id: '41_60', label: '41–60', pct: 24 },
  { id: '61_plus', label: '61+', pct: 12 },
];

export function countFor(pct) {
  return Math.round((pct / 100) * TOTAL_VOICES);
}
